import React, { memo, useRef } from 'react';

import { Modal, Button, Form, Input, Alert } from 'antd';
// import { useTheme } from 'utils/Theme';
import { useNavigate } from 'react-router';

import { Container } from './AddUserModal.style';

export interface AddUserModalProps {
  isSubmitting: boolean;
  onSubmit: (data: { consultantEmail: string }) => void;
  isError: boolean;
}

const AddUserModal = (props: AddUserModalProps): JSX.Element => {
  const navigate = useNavigate();
  const submitButton = useRef<HTMLButtonElement>(null);
  // const theme = useTheme();

  return (
    <Modal
      title="Add User Form"
      centered
      visible
      // onOk={() => {}}
      onCancel={() => {
        navigate('/dashboard/user-management');
      }}
      width="50%"
      footer={[
        <Button
          key="back"
          onClick={() => {
            navigate('/dashboard/user-management');
          }}
        >
          Return
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={props.isSubmitting}
          onClick={() => submitButton.current?.click()}
        >
          Submit
        </Button>,
      ]}
    >
      {props.isError && (
        <Alert
          message="An error has occurred"
          type="error"
          style={{ marginBottom: '16px' }}
        />
      )}
      <Form
        name="basic"
        initialValues={{ remember: true }}
        onFinish={props.onSubmit}
      >
        <Form.Item
          label="Consultant Email"
          name="consultantEmail"
          rules={[
            { required: true, message: 'Please input the consultant email' },
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item>
          <div style={{ textAlign: 'right' }}>
            <Button type="primary" htmlType="submit" hidden ref={submitButton}>
              Submit
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default memo(AddUserModal);
